var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolDefs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lock",
    viewBox: "0 0 15 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 0.8,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.28,
    d: "M10.88 7.36v-1.92c0-1.767-1.433-3.2-3.2-3.2s-3.2 1.433-3.2 3.2v0 1.92M4.992 13.76h5.376c1.075 0 1.613 0 2.024-0.209 0.363-0.188 0.651-0.476 0.834-0.828l0.005-0.011c0.209-0.411 0.209-0.948 0.209-2.024v-0.256c0-1.075 0-1.613-0.209-2.024-0.188-0.363-0.476-0.651-0.828-0.834l-0.011-0.005c-0.411-0.209-0.948-0.209-2.024-0.209h-5.376c-1.075 0-1.613 0-2.024 0.209-0.363 0.188-0.651 0.476-0.834 0.828l-0.005 0.011c-0.209 0.411-0.209 0.948-0.209 2.024v0.256c0 1.075 0 1.613 0.209 2.024 0.188 0.363 0.476 0.651 0.828 0.834l0.011 0.005c0.411 0.209 0.948 0.209 2.024 0.209z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mail",
    viewBox: "0 0 15 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 0.8,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.28,
    d: "M1.28 4.8l5.226 3.658c0.423 0.296 0.635 0.445 0.865 0.502 0.093 0.024 0.2 0.038 0.31 0.038s0.217-0.014 0.319-0.040l-0.009 0.002c0.23-0.058 0.442-0.205 0.865-0.502l5.226-3.658M4.352 13.12h6.656c1.075 0 1.613 0 2.024-0.209 0.363-0.188 0.651-0.476 0.834-0.828l0.005-0.011c0.209-0.411 0.209-0.948 0.209-2.024v-4.096c0-1.075 0-1.613-0.209-2.024-0.188-0.363-0.476-0.651-0.828-0.834l-0.011-0.005c-0.411-0.209-0.948-0.209-2.024-0.209h-6.656c-1.075 0-1.613 0-2.024 0.209-0.363 0.188-0.651 0.476-0.834 0.828l-0.005 0.011c-0.209 0.411-0.209 0.948-0.209 2.024v4.096c0 1.075 0 1.613 0.209 2.024 0.188 0.363 0.476 0.651 0.828 0.834l0.011 0.005c0.411 0.209 0.948 0.209 2.024 0.209z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 15 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 0.8,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.28,
    d: "M12.8 13.76c0-0.893 0-1.34-0.11-1.703-0.254-0.82-0.887-1.453-1.689-1.702l-0.018-0.005c-0.364-0.11-0.81-0.11-1.703-0.11h-3.2c-0.893 0-1.34 0-1.703 0.11-0.82 0.254-1.453 0.887-1.702 1.689l-0.005 0.018c-0.11 0.364-0.11 0.81-0.11 1.703M10.56 5.12c0 1.591-1.289 2.88-2.88 2.88s-2.88-1.289-2.88-2.88v0c0-1.591 1.289-2.88 2.88-2.88s2.88 1.289 2.88 2.88v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM6.83594 8.12891L8.67578 9.96484L6.83594 11.8359C6.47266 12.2031 6.47266 12.7969 6.83594 13.1289C7.20312 13.5273 7.79688 13.5273 8.12891 13.1289L9.96484 11.3242L11.8359 13.1289C12.2031 13.5273 12.7969 13.5273 13.1289 13.1289C13.5273 12.7969 13.5273 12.2031 13.1289 11.8359L11.3242 9.96484L13.1289 8.12891C13.5273 7.79688 13.5273 7.20312 13.1289 6.83594C12.7969 6.47266 12.2031 6.47266 11.8359 6.83594L9.96484 8.67578L8.12891 6.83594C7.79688 6.47266 7.20312 6.47266 6.83594 6.83594C6.47266 7.20312 6.47266 7.79688 6.83594 8.12891Z",
    fill: "#E74A3B"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-valid",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47656 4.47656 0 10 0C15.5234 0 20 4.47656 20 10C20 15.5234 15.5234 20 10 20C4.47656 20 0 15.5234 0 10ZM14.5234 8.27344C14.9492 7.84766 14.9492 7.15234 14.5234 6.72656C14.0977 6.30078 13.4023 6.30078 12.9766 6.72656L8.75 10.9531L7.02344 9.22656C6.59766 8.80078 5.90234 8.80078 5.47656 9.22656C5.05078 9.65234 5.05078 10.3477 5.47656 10.7734L7.97656 13.2734C8.40234 13.6992 9.09766 13.6992 9.52344 13.2734L14.5234 8.27344Z",
    fill: "#3CBC81"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M1.333 1.47v7.271c0 2.076 0.906 3.914 2.31 5.104 0.687 0.582 1.141 1.367 1.141 2.239v12.138c0 1.349 1.16 2.445 2.588 2.445s2.588-1.095 2.588-2.445v-12.138c0-0.872 0.454-1.657 1.141-2.239 1.405-1.19 2.31-3.028 2.31-5.104v0 2.31-9.104v0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M7.372 9.482v-8.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M30.667 3.047c0-0.9-0.773-1.63-1.725-1.63h-1.726c-2.859 0-5.176 2.189-5.176 4.889v9.778c0 2.125 1.444 3.916 3.451 4.589v7.549c0 1.349 1.16 2.445 2.588 2.445s2.588-1.095 2.588-2.445v-25.175z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.3ea2db432ca94c24613bc9cc08df3ce9.svg";
export { ForwardRef as ReactComponent };